import type { Query } from './query'

export abstract class Repository<T> {
  abstract get(query: Query): Promise<T[] | never[]>
}
